module.exports = __webpack_public_path__ + "img/oaFlowData192@3x.6d5184cd.png";